export enum ActiveStep {
  KEY_CREATION = 1,
  KEY_ASSIGN = 2,
}

export default ActiveStep;
